import React from 'react'
import styled from 'styled-components'
import { Link, graphql, useStaticQuery } from 'gatsby'

import EmailList from './EmailList'

const StyledFooter = styled.footer`
  width: 100%;
  background-color: var(--color-secondary);

  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
`

const Content = styled.div`
  width: 1296px;
  padding: 0rem 2rem;
  padding-top: 3rem;
  margin: 0 auto;
  display: flex;
  align-items: center;
  flex-direction: column;

  color: var(--color-primary);

  @media only screen and (max-width: 1313px) {
    width: 100%;
  }
`

const InfoDiv = styled.div`
  width: 100%;
  height: 180px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-flow: row;
  margin-bottom: 3rem;

  h3 {
    margin: 0;
  }

  a {
    font-size: 1.3rem;
    text-decoration: none;
    color: var(--color-primary);

    &:hover,
    &:focus {
      color: var(--color-secondaryCompliment);
    }
  }

  @media only screen and (max-width: 767px) {
    height: 600px;
    flex-flow: column;
    text-align: center;
  }
`

export const ColDiv = styled.div`
  max-width: 400px;
  height: 100%;
  display: flex;
  justify-content: space-around;
  flex-flow: column;
  padding: 0rem 1rem;

  h1,
  h2 {
    margin: 0;
  }
  p {
    margin: 0;
  }

  button {
    background-color: var(--color-secondaryCompliment);
    color: '#000';
    padding: 0.8rem 2rem;
    font-family: 'Bungee';
    font-size: 1rem;
    border: none;
    cursor: pointer;
    &:hover,
    &:focus {
      background-color: #bdbdbd;
    }
  }

  @media only screen and (max-width: 767px) {
    height: 30%;
  }
`

export const LinksDiv = styled.div`
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-flow: row;
  border-bottom: 1px solid var(--color-primary);
  border-top: 1px solid var(--color-primary);
  padding: 2rem 0rem;
  letter-spacing: 0.5px;

  div {
    width: 400px;
    display: flex;
    justify-content: space-around;

    @media only screen and (max-width: 1100px) {
      width: 290px;
      justify-content: space-around;
      flex-flow: row wrap;
    }
    @media only screen and (max-width: 767px) {
      width: 270px;
    }

    @media only screen and (max-width: 267px) {
      width: 100%;
      justify-content: space-around;
      flex-flow: row wrap;
    }
  }

  a {
    color: var(--color-primary);
    font-size: 1.2rem;
    text-decoration: none;
    padding: 1rem;

    i {
      color: var(--color-primary);
      font-size: 1.3rem;
    }

    &:hover,
    &:focus {
      color: var(--color-secondaryCompliment);

      i {
        color: var(--color-secondaryCompliment);
      }
    }

    @media only screen and (max-width: 1100px) {
      font-size: 1.1rem;
    }
  }

  @media only screen and (min-width: 768px) and (max-width: 1100px) {
    .category-footer {
      width: 110px;
    }
  }
  @media only screen and (max-width: 767px) {
    height: 300px;
    flex-flow: column;
  }
`

const BrandDiv = styled.div`
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: row;
  border-bottom: 1px solid var(--color-primary);
  padding: 2rem 0rem;

  h3 {
    margin: 0;
    padding: 2rem;
  }

  @media only screen and (max-width: 767px) {
    height: 100%;
    flex-flow: column;
  }
`

const Disclaimer = styled.div`
  max-width: 770px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-flow: column;
  margin: 0 auto;
  padding: 2rem 0rem;
  text-align: center;
  font-size: 0.75rem;

  p {
    margin: 0;
    line-height: 1.4;
  }

  @media only screen and (max-width: 767px) {
    height: 100%;
  }
`

export default function Footer() {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          author {
            name
          }
        }
      }
    }
  `)

  return (
    <StyledFooter>
      <EmailList />
      <Content>
        <InfoDiv>
          <ColDiv>
            <h1>TechBlog</h1>
            <h2>As Featured On:</h2>
          </ColDiv>
          <ColDiv>
            <Link to="/about/">About</Link>
            <Link to="/careers/">Careers</Link>
            <Link to="/privacy/">Privacy Policy</Link>
            <Link to="/terms-of-use/">Terms of Use</Link>
            <Link to="/contact/">Contact Us</Link>
          </ColDiv>
          <ColDiv>
            <h2>Get Involved</h2>
            <p>Connect with other TechBlog readers in our online community.</p>
            <button>Join our Discord Server!</button>
          </ColDiv>
        </InfoDiv>
        <LinksDiv>
          <Link className="category-footer" to="/computing/">
            Computing
          </Link>
          <Link className="category-footer" to="/gaming/">
            Gaming
          </Link>
          <Link className="category-footer" to="/productivity/">
            Productivity
          </Link>
          <Link className="category-footer" to="/vehicles/">
            Vehicles
          </Link>
          <div>
            <a
              href="https://twitter.com/ElektrikSpark"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
            >
              <i className="fab fa-twitter"></i>
            </a>
            <a
              href="https://facebook.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <i className="fab fa-facebook"></i>
            </a>
            <a
              href="https://instagram.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a
              href="https://linkedin.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <i className="fab fa-linkedin"></i>
            </a>
            <a
              href="https://youtube.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Youtube"
            >
              <i className="fab fa-youtube"></i>
            </a>
          </div>
        </LinksDiv>
        <BrandDiv>
          <h3>
            <span>OUR BRANDS:</span>
          </h3>
          <h3>
            <span>TwinZ</span>
          </h3>
        </BrandDiv>
        <Disclaimer>
          <p>{`TechBlog.com is owned by ${data.site.siteMetadata.author.name} LLC and is a participant in the Amazon Services LLC Associates Program, an affiliate advertising program designed to provide a means for sites to earn advertising fees by advertising and linking to Amazon.com. As an Amazon Associate and partner with other affiliate programs, Techblog earns from referring traffic and qualifying purchases.`}</p>
          <br></br>
          <p>Copyright © 2019 TwinZ LLC</p>
        </Disclaimer>
      </Content>
    </StyledFooter>
  )
}
